module.exports = "\n\n\n\n  <router-outlet>\n  </router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main